<template>
  <div id="find-pw">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <div class="done-wrapper">
      <div class="done-container">
        <img src="../../assets/logo-white.png" class="logo-img small" alt="">
        <!-- <h1 style="margin-top:0">SVTN</h1>
        <p style="margin-bottom: 2em;" v-html="$t('acc.findPw.content')"></p> -->
        <form-input
          :inputType="typeEmail"
          :placeholderText="emailHolder"
          :inputValue="email"
          @inputParent="value => { email = value }"
        />
        <form-button
          :btnName="buttonName"
          @parentCall="sendEmail"
        />
      </div>
    </div>
    <CompModal
      v-if="showModal"
      @confirm="showModal = false"
    >
      <div slot="body">{{ modalBody }}</div>
    </CompModal>
  </div>
</template>

<script>
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import CompHeader from '@/components/CompHeader';
import FormInput from '@/components/FormInput';
import FormButton from '@/components/FormButton';
import CompModal from '@/components/CompModal';

export default {
  name: 'find-pw',
  mixins: [
    common,
  ],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('acc.findPw.header'),

      email: '',
      typeEmail: 'email',
      emailHolder: this.$i18n.t('acc.findPw.holder'),

      buttonName: this.$i18n.t('acc.findPw.button'),

      showModal: false,
      modalBody: '',

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompModal,
    CompHeader,
    FormInput,
    FormButton,
  },
  methods: {
    sendEmail() {
      const email = {
        userId: this.email,
      };
      this.$store.dispatch('sendPwEmail', { email })
        .then(({ error }) => {
          if (error.resultCode === RESPONSE.SUCCESS.MAIL.CODE) {
            this.modalBody = this.$i18n.t('acc.findPw.result');
          } else {
            this.modalBody = error.resultMsg;
          }
          this.showModal = true;
        });
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-done.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-find-pw.vue